export default [
  // {
  //   path: '/admin/shipping-methods',
  //   name: 'indexShippingMethodsAdmin',
  //   meta: { title: 'indexShippingMethodsAdmin' },
  //   component: () => import('@/pages/admin/shipping-methods'),
  // },
  // {
  //   path: "/admin/shipping-methods/create",
  //   name: "createShippingMethodsAdmin",
  //   meta: { title: 'createShippingMethodsAdmin' },
  //   component: () => import('@/pages/admin/shipping-methods/create'),
  // },
  // {
  //   path: "/admin/shipping-methods/:id/edit",
  //   name: "editShippingMethodsAdmin",
  //   meta: { title: 'editShippingMethodsAdmin' },
  //   component: () => import('@/pages/admin/shipping-methods/edit'),
  // },
]
